import { reactQueryUtils } from "@lib/react-query";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "./onboarding.api";
import { onboardingKeys } from "./onboarding.keys";
import type { TEndTourPayload } from "./onboarding.types";

const invalidateState = () =>
  reactQueryUtils.invalidateQueries([...onboardingKeys.state]);

export const useEndPlatformTourMutation = () =>
  useMutation({
    mutationFn: (payload: TEndTourPayload) => onboardingApi.endTour(payload),
    onSettled: invalidateState,
  });

export const useVerifyTeamWalkthroughMutation = () =>
  useMutation({
    mutationFn: () => onboardingApi.verifyTeamWalkthrough(),
    onSettled: invalidateState,
  });
